import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { IconComponent } from '@atoms/icon/icon.component';
import { CheckboxComponent } from '@atoms/checkbox/checkbox.component';
import { StickerComponent } from '@atoms/sticker/sticker.component';
import { Dropdown } from '@models/inputs.model';

@Component({
  selector: 'app-dropdown-list-item',
  imports: [NgClass, NgTemplateOutlet, IconComponent, CheckboxComponent, StickerComponent],
  templateUrl: './dropdown-list-item.component.html',
  styleUrls: ['./dropdown-list-item.component.scss'],
})
export class DropdownListItemComponent {
  @Input() type: 'list' | 'checkbox' | 'radio' = 'list';
  @Input() value: string | number = '';
  @Input() active: boolean = false;
  @Input() href?: string;
  @Input() name: string = '';
  @Input() count?: number;
  @Output() clicked: EventEmitter<Dropdown> = new EventEmitter<Dropdown>();
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  click(e?: Event): void {
    if (e) e.preventDefault();
    this.clicked.emit({ value: this.value, active: this.active });
    this.activeChange.emit(this.active);
  }

  linkClick(e: Event): void {
    e.preventDefault();
    const active = !this.active;
    this.clicked.emit({ value: this.value, active: active });
    this.activeChange.emit(active);
  }
}
